module.exports = __webpack_public_path__ + "static/lanlogo-2df9420fc1b9367ac95f921d50c03de7.png";